import React from 'react';
import { FadeIn } from './FadeIn';
import { UserMinusIcon, TrendingUpIcon, ActivityIcon, DollarSignIcon } from 'lucide-react';
export function PainStories() {
  const pains = [{
    icon: <UserMinusIcon className="w-8 h-8 text-red-400" data-id="element-100" />,
    title: 'El alumno que abandona sin decir por qué',
    text: 'Llevaba 4 meses entrenando con vos. Progresó. Lo viste mejorar. Pero no tenés cómo demostrárselo. No hay registro, no hay datos, no hay evidencia concreta del camino recorrido. Un día deja de venir. Y vos sabés que no fue por falta de mejora. Fue porque no pudo verla.'
  }, {
    icon: <ActivityIcon className="w-8 h-8 text-orange-400" data-id="element-101" />,
    title: 'La lesión que se repite',
    text: 'El mismo alumno, la misma rodilla, el mismo mes. Y vos ya sabés que es el volumen, o la técnica, o la fuerza que no tiene. Pero sin un sistema de prevención estructurado, la conversación siempre llega después del problema. Nunca antes.'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8 text-yellow-400" data-id="element-102" />,
    title: 'El muro del kilómetro 30 que nadie anticipó',
    text: 'Tu alumno lleva meses preparando el maratón. El plan está. El entrenamiento está. Pero la nutrición, la recuperación y la estrategia de carrera son improvisadas. Y en el kilómetro 30, el muro llega. Y vos sentís que algo en la preparación falló.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-running-blue" data-id="element-103" />,
    title: 'El techo que no podés romper',
    text: 'Llevás dos años cobrando lo mismo porque cada vez que pensás en subirlo aparece la misma pregunta: ¿y si se van? ¿Cómo lo justifico? ¿Qué me diferencia del profe que cobra la mitad? La respuesta es que no tenés el argumento construido. Todavía.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-running-dark" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <FadeIn data-id="element-106">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-107">
            Y mientras tanto,{' '}
            <span className="text-red-400" data-id="element-108">pasan cosas que duelen.</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-109">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-110">
              <div className="bg-running-surface border border-running-muted p-6 sm:p-8 rounded-2xl h-full hover:border-running-blue/30 transition-colors" data-id="element-111">
                <div className="bg-running-dark w-16 h-16 rounded-xl flex items-center justify-center mb-6 border border-running-muted" data-id="element-112">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-113">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-114">{pain.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}